import { Dropdown } from 'components/dropdown/Dropdown';
import {
    getIssueSeverity,
    IssueSeverities,
    IssueSeverity,
} from 'pages/Desk/issues/shared';
import { Text, useIssueSidebarDropdownTriggerOptions } from 'pages/Desk/issues/styled';
import { CSSProperties, useMemo } from 'react';
import { SecondaryText } from 'styles/theme_styles/text';

export type IssueSeverityDropdownProps = Readonly<{
    id?: string;
    value: number | undefined;
    className?: string;
    style?: CSSProperties;
    onChange: (newValue: number) => void;
    isDisabled?: boolean;
}>;

export function IssueSeverityDropdown({
    id,
    value,
    className,
    style,
    onChange,
    isDisabled = false,
}: IssueSeverityDropdownProps) {
    const severity = useMemo(
        () => (value !== undefined ? getIssueSeverity(value) : undefined),
        [value]
    );

    return (
        <Dropdown<IssueSeverity>
            id={id}
            trigger={{ ...useIssueSidebarDropdownTriggerOptions(style), className }}
            dataKey={({ label: name }) => name}
            renderLabel={(info) => (
                <SecondaryText>
                    {info.value?.label ?? 'Choose the Severity'}
                </SecondaryText>
            )}
            renderItem={({ item }) => <Text>{item.label}</Text>}
            data={IssueSeverities}
            value={severity}
            onChange={(newValue) => onChange(newValue.severityValue)}
            isDisabled={isDisabled}
        />
    );
}
